const url = document.referrer;
  function obtenerPalabraSiguiente(url) {
  // Verifica si la URL contiene la palabra "collections"
  if (url.includes("collections")) {
    localStorage.removeItem('referrerUrl');
    localStorage.removeItem('Url');
    // Divide la URL en partes usando "/"
    const partes = url.split("/");
    
    // Encuentra el índice de "collections"
    const indice = partes.indexOf("collections");

// Verifica si hay una palabra después de "collections"
    if (indice !== -1 && partes[indice + 1]) {
      let nameCollection = partes[indice + 1];
       nameCollection  = nameCollection.replace(/-/g, " ");
      
      localStorage.setItem('referrerUrl', nameCollection );
      localStorage.setItem('Url', url);
      return partes[indice + 1];
    } else {
      return null; // No hay palabra después de "collections"
    }
  } else {
    return null; // La URL no contiene "collections"
  }
}


const resultado = obtenerPalabraSiguiente(url);
if(resultado !== null){

  setTimeout(breadcrubChange, 30)
}
const storedCollection = localStorage.getItem('referrerUrl');
const storedUrl = localStorage.getItem('Url');

if (storedCollection) {
    // Aquí puedes usar storedCollection según tus necesidades
    setTimeout(() => breadcrubChange(storedCollection,storedUrl), 10);
} 

function breadcrubChange(storedCollection,storedUrl){
  const aElement = document.getElementById('Breadcrumbs-item');
  const aElement_movil = document.getElementById('Breadcrumbs-item-movil');

  if(aElement) {
    aElement.textContent = capitalizarPrimeraLetra(storedCollection);
    aElement.href = storedUrl;
    aElement.style.display = 'block';
  }
  if(aElement_movil) {
    aElement_movil.textContent = capitalizarPrimeraLetra(storedCollection);
    aElement_movil.href = storedUrl;
    aElement_movil.style.display = 'block';
  }
}

function capitalizarPrimeraLetra(cadena) {
  if (cadena.length === 0) {
    return cadena; // Retorna la cadena vacía si no tiene caracteres
  }
  return cadena.charAt(0).toUpperCase() + cadena.slice(1);
}